import { useState, useEffect } from "react";

const useSelectedDomain = () => {
    const [selectedDomain, setSelectedDomain] = useState(null);

    useEffect(() => {
        // Vérifier si un domaine est sélectionné dans sessionStorage (pour un admin)
        const storedDomain = sessionStorage.getItem("selectedDomain");
        if (storedDomain) {
            setSelectedDomain(JSON.parse(storedDomain));
            return;
        }

        // Sinon, récupérer le domaine du manager depuis l'auth (si un manager est connecté)
        const userData = JSON.parse(localStorage.getItem("userData")); // Stocke bien userData dans localStorage lors de la connexion
        if (userData && userData.role === "manager" && userData.selectedDomain) {
            setSelectedDomain(userData.selectedDomain);
        }
    }, []);

    return selectedDomain;
};

export default useSelectedDomain;
